export default {
      id: "agility-2-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#agility-2",
      toString: function () {
        return this.url;
      }
    }